import { createContext, useContext } from 'react';
import type {
  KnowledgeMessage,
  KnowledgeMessageAttachment,
  KnowledgeSession,
} from '../../api';

export interface KnowledgeChatContextValue {
  session?: KnowledgeSession;
  messages: KnowledgeMessage[];
  isSending: boolean;
  sendMessage(
    message: string,
    attachments?: KnowledgeMessageAttachment[],
  ): Promise<void>;
  abortMessage(): void;
  uploadFiles(files: File[]): Promise<void>;
  resetSession?(): Promise<void>;
}

export const KnowledgeChatContext = createContext<
  KnowledgeChatContextValue | undefined
>(undefined);

export function useKnowledgeChatContext() {
  const value = useContext(KnowledgeChatContext);
  if (!value) {
    throw new Error(
      'useKnowledgeChatContext must be used inside a KnowledgeChatContext.Provider',
    );
  }
  return value;
}
